import classNames from 'classnames';
import { ReactNode } from 'react';

import styles from './step-header.module.scss';

const StepHeader = ({
  titleClassName,
  subtitleClassName,
  title,
  subtitle,
}: {
  titleClassName?: string;
  subtitleClassName?: string;
  title: ReactNode;
  subtitle?: ReactNode;
}) => (
  <>
    <h2 className={classNames(styles.title, titleClassName)}>{title}</h2>
    {subtitle && (
      <p className={classNames(styles.subtitle, subtitleClassName)}>
        {subtitle}
      </p>
    )}
  </>
);

export default StepHeader;
